import { underscore } from 'inflected';
import { isPlainObject } from 'lodash-es';
export const underscoreKeys = (object) => {
    // Arrayは再帰実行
    if (Array.isArray(object)) {
        return object.map((v) => underscoreKeys(v));
    }
    // Object以外はそのまま返却
    if (!(object instanceof Object)) {
        return object;
    }
    if (isPlainObject(object) || Object.getPrototypeOf(object) === Object.prototype) {
        const underscored = {};
        Object.keys(object).forEach((key, _) => {
            underscored[underscore(key)] = underscoreKeys(object[key]);
        });
        return underscored;
    }
    // ------- 以降は Object や Array ではなく、Class判定 --------
    // jsonに変換できないClassはそのまま返却する
    if (object instanceof FormData) {
        return object;
    }
    // Classは一度jsonに変換してから、Objectとして、underscoreKeys()を実行する
    return underscoreKeys(JSON.parse(JSON.stringify(object)));
};
